import React, {createContext, FC, useState} from 'react'
import {Key, MetadataKey} from '../backend/model';

interface GlobalDataState {
    iapMetadataKeys: MetadataKey[];
    iogMetadataKeys: MetadataKey[];
    inputSearchKeys: Key[]
    outputSearchKeys: Key[]
    setIapMetadataKeys: (metadataKeys: MetadataKey[]) => void;
    setIogMetadataKeys: (metadataKeys: MetadataKey[]) => void;
    setInputSearchKeys: (keys: Key[]) => void;
    setOutputSearchKeys: (keys: Key[]) => void;
}

const GlobalDataContext = createContext<GlobalDataState>({
    iapMetadataKeys: [],
    iogMetadataKeys: [],
    inputSearchKeys: [],
    outputSearchKeys: [],
    setIapMetadataKeys: () => {
    },
    setIogMetadataKeys: () => {
    },
    setInputSearchKeys: () => {
    },
    setOutputSearchKeys: () => {
    },
})

export const GlobalDataProvider: FC = ({children}) => {
    const [iapMetadataKeys, setIapMetadataKeys] = useState<MetadataKey[]>([])
    const [iogMetadataKeys, setIogMetadataKeys] = useState<MetadataKey[]>([])
    const [inputSearchKeys, setInputSearchKeys] = useState<Key[]>([])
    const [outputSearchKeys, setOutputSearchKeys] = useState<Key[]>([])

    return (
        <GlobalDataContext.Provider value={{
            iapMetadataKeys,
            iogMetadataKeys,
            inputSearchKeys,
            outputSearchKeys,
            setIapMetadataKeys,
            setIogMetadataKeys,
            setInputSearchKeys,
            setOutputSearchKeys,
        }}>
            {children}
        </GlobalDataContext.Provider>
    )
}

export default GlobalDataContext
